<!-- <div [hidden]="!show">
    <div [class]="cssClass">
        <div [hidden]="!show">
            <i class="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</div> -->

<div [hidden]="!show">
    <div [class]="cssClass">
        <div [class]="loaderClass" [hidden]="!show">
            <p-progressSpinner [style]="{width: '80px', height: '80px'}" strokeWidth="2" animationDuration=".9s">
            </p-progressSpinner>
        </div>
    </div>
</div>